import type { JSONContent } from '@tiptap/react'
import type { EmptyObject } from '@/utils/primitives'
import type { NodeAttributes } from '../tiptap-helpers'

import { Node, ReactNodeViewRenderer, mergeAttributes } from '@tiptap/react'

import { ImageNodeViewLive } from './ImageNodeView'

export const IMAGENODE_NAME = 'rsImageNode' as const
export const IMAGENODE_TAG = 'img' as const

/** @deprecated We're migrating from `<img-component/>` to native `<img/>` */
export const IMAGENODE_TAG_LEGACY = 'img-component' as const

type ImageNodeOptions = EmptyObject

export type ImageNodeAttributes = {
  src: string
  width?: number
  height?: number
}

export const ImageNode = Node.create<ImageNodeOptions, ImageNodeAttributes>({
  name: IMAGENODE_NAME,
  group: 'block',
  atom: true,
  defining: true,
  selectable: true,

  addAttributes() {
    return {
      src: { default: '' },
      width: { default: undefined },
      height: { default: undefined },
    } satisfies NodeAttributes<ImageNodeAttributes>
  },

  parseHTML() {
    return [
      { tag: IMAGENODE_TAG },
      { tag: IMAGENODE_TAG_LEGACY }, // Parse legacy tag during migration period
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [IMAGENODE_TAG, mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeViewLive)
  },
})

/** Strictly typed Tiptap JSON content block */
export interface ImageNodeBlock extends JSONContent {
  type: typeof IMAGENODE_NAME
  attrs: ImageNodeAttributes
}

/** Create a (compile-time) type-safe Tiptap JSON content block */
export function createImageBlock(attrs: ImageNodeAttributes): ImageNodeBlock {
  return {
    type: IMAGENODE_NAME,
    attrs: attrs,
  }
}
